import {
  API_HOST,
  getHttpPostOptions,
  getHttpGetOptions,
  getHttpPutOptions,
  getHttpDeleteOptions
} from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/post`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;

export const getCreatePostRequest = (post) => [getEndpoint(), getHttpPostOptions(post)];

const getViewPostsEndpoint = (programmeExternalReference) => `${getSpecificEndpoint(programmeExternalReference)}`;
export const getViewPostsRequest = (programmeExternalReference, page, size, searchType, memberExternalReference) => [
  getViewPostsEndpoint(programmeExternalReference),
  getHttpGetOptions(undefined, { searchType, page, size, memberExternalReference })
];

export const getUpdatePostRequest = (post) => [getEndpoint(), getHttpPutOptions(post)];

export const getDeletePostRequest = (postExternalReference) => [
  `${getSpecificEndpoint(postExternalReference)}`,
  getHttpDeleteOptions()
];

const getSearchPostsEndpoint = (programmeExternalReference, searchValue) =>
  `${getEndpoint()}/${programmeExternalReference}/${searchValue}`;
export const getSearchPostsRequest = (programmeExternalReference, memberExternalReference, searchValue) => [
  getSearchPostsEndpoint(programmeExternalReference, searchValue),
  getHttpGetOptions(undefined, { memberExternalReference })
];

const getViewPostHierarchyEndpoint = (externalReference) => `${getEndpoint()}/view/post-hierarchy/${externalReference}`;
export const getViewPostHierarchyRequest = (externalReference) => [
  getViewPostHierarchyEndpoint(externalReference),
  getHttpGetOptions()
];
